<div *ngIf="modulePermitted$ | async; else notPermitted">
    <bx-disclaim
        id="bx-disclaim-quote-reqs"
        [contents]="(notices$ | async)!"
        (actionClicked)="onDisclaimClicked($event)"
        [enableDismissAll]="true"
        (dismissAllClicked)="onDismissAll()">
    </bx-disclaim>

    <div class="alert alert-block alert-info padding-5">
        New Requests for Quotes can be created through Estimate Costings or Job Actual Costings
    </div>

    <app-ui-quoterequests-table></app-ui-quoterequests-table>

    <help-note-wrapper
        title="Request For Quote Listing"
        url="https://help.buildxact.com/en/?q=%22quote+request%22"
        footer="Read more in our FAQ’s"
        setting="NoteQuoteRequest"
        *ngIf="!showingDeleted"
        [expanded]="true">
        Here is where you can see at a glance the request for quotes you have issued across all your estimates and jobs and have the ability
        to re-edit and share them. To send out a new request for quote, go in to an estimate then Estimate Costings and select items you
        want quote requests for from there. Or go in to a job then Actual Costing and select items you want to quote request.
    </help-note-wrapper>
</div>
<ng-template #notPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
